<section class="animation-fase-in">
  <p class="green">Need to talk to us?</p>
  <p>+44 (0)20 8004 2630</p>
  <div class="wrapper">
    <img src="assets/icons/email.svg">
    <p><a href="mailto:info@blancliving.co">Email us</a></p>
  </div>
</section>
